import { createAdapter } from "./i18n.mjs";
import { defineNuxtPlugin } from "#imports";
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("vuetify:configuration", ({ vuetifyOptions }) => {
    createAdapter(vuetifyOptions);
  });
});
